import React from 'react';
import ErrorMessage from './errorMessage';

const FormField = ({
  label,
  name,
  errortext,
  type,
  registerfunc,
  errorsfunc,
}) => (
  <>
    <label className="mb0 pb0 k--label" htmlFor={name}>
      {label}
    </label>

    <input
      name={name}
      className={`${
        errorsfunc[name] ? `b--red` : ``
      } input-reset db border-box w-100 mw-100 pa2 bg-white-30 hover-bg-white-70 outline-0 hover-gray ba k--input`}
      type={type}
      id={name}
      ref={registerfunc({ required: true })}
    />

    {errorsfunc.errors &&
      Object.entries(errorsfunc.errors).map(([e, v]) => (
        <p
          className="red f7 mb0 pb0"
          style={{
            // visibility: `${errorsfunc[name] ? "visible" : "hidden"}`,
            visibility: 'visible',
          }}
        >
          {v.message}
        </p>
      ))}
  </>
);

export default FormField;
